import Experience from '../Experience.js'
import EventEmitter from './EventEmitter.js'

export default class Time extends EventEmitter {
    constructor() {
        super()
        this.experience = new Experience()
        this.stats = this.experience.stats
        this.debug = this.experience.debug

        if (this.debug.active && this.stats) {
            this.stats.showPanel(0)
            document.body.appendChild(this.stats.dom)
        }

        // Setup
        this.start = Date.now()
        this.current = this.start
        this.elapsed = 0
        this.delta = 16
    }

    tick() {
        if(this.stats) this.stats.begin()

        const currentTime = Date.now()
        this.delta = currentTime - this.current
        this.current = currentTime
        this.elapsed = this.current - this.start

        this.trigger('tick')

        if(this.stats) this.stats.end()
    }
}